// extracted by mini-css-extract-plugin
var _1 = "KErEtBZQMndXQeSeQfbN";
export { _1 as "heading" }
